import { render, staticRenderFns } from "./vipLevel.vue?vue&type=template&id=ecca24ce&scoped=true&"
import script from "./vipLevel.vue?vue&type=script&lang=js&"
export * from "./vipLevel.vue?vue&type=script&lang=js&"
import style0 from "./vipLevel.vue?vue&type=style&index=0&id=ecca24ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecca24ce",
  null
  
)

export default component.exports